<template>
  <div id="app">
    <router-view> </router-view>
  </div>
</template>

<script>

export default {
  name: "App",
  components: {
      
  }
}
</script>

<style lang="stylus">
  @import "./styles/Global.styl"
  @import "./styles/Grid.styl"
</style>
